export enum HouseReason {
    ACCEPTED = 'accepted',
    OFFER = 'offer',
    ORIENTATING = 'orientating'
}

export enum Reason {
    FIRST_HOUSE = 'first_house',
    NEXT_HOUSE = 'next_house',
    ADJUST_MORTGAGE = 'adjust_mortgage',
    REFINANCE_MORTGAGE = 'refinance_mortgage',
    MAINTENANCE_MEETING = 'maintenance_meeting',
    DIFFERENT_QUESTION = 'different_question'
}
